export class EnfaceSocket {
  constructor({ address, onClose }) {
    this.address = address;
    this.onClose = onClose;
  }

  encode(data) {
    return JSON.stringify(data);
  }

  decode(data) {
    return JSON.parse(data);
  }

  open() {
    return new Promise((resolve, reject) => {
      this.ws = new WebSocket(this.address);
      this.ws.onopen = async event => {
        // console.log('[EnfaceSocket].onopen', { socket: event.target });
        resolve(event.target);
      };
      this.ws.onclose = event => {
        // console.log('[EnfaceSocket].onclose', { event, 'this.ws.rejector': this.ws.rejector });
        this.ws.rejector && this.ws.rejector(new Error('Connection closed'));
        this.onClose && this.onClose(event);
      };
      this.ws.onmessage = async event => {
        console.log('[EnfaceSocket].onmessage', this.encode(event.data, null, ' '));
        try {
          const json = this.decode(event.data);
          console.log('[EnfaceSocket].onmessage', { json });
          return json._ === 'error'
            ? this.ws.rejector
              ? this.ws.rejector(new Error(json.message))
              : this.ws.resolver({
                _: json._,
                message: json.message || '',
                ...json.payload,
              })
            : this.ws.resolver({
              _: json._,
              message: json.message || '',
              ...json.payload,
            });
        } catch (error) {
          console.error('[EnfaceSocket].onmessage', error);
          this.ws.rejector && this.ws.rejector(new Error('Bad server response'));
        }
      };
      this.ws.onerror = error => {
        console.log('[ws.onerror]', { error });
        reject(new Error('Connection failed'));
      };
    });
  }

  close() {
    this.ws && this.ws.close();
  }

  send({ data, onMessage }) {
    console.log('[EnfaceSocket].send', data);
    return new Promise(async (resolve, reject) => {
      try {
        if (this.ws.readyState === WebSocket.OPEN) {
          this.ws.rejector = payload => {
            // console.log('[EnfaceSocket].rejector');
            this.ws.resolver = null;
            this.ws.rejector = null;
            reject(data);
          };
          this.ws.resolver = payload => {
            // console.log('[EnfaceSocket].resolver');
            this.ws.rejector = null;
            onMessage(payload);
            resolve(true);
          };
          const encoded = this.encode(data);
          console.log('[EnfaceSocket].send', { encoded });
          this.ws.send(encoded);
        } else {
          console.error('[EnfaceSocket].send socket not open');
          reject(new Error('Websocket is closed'));
        }
      } catch (error) {
        reject(error);
      }
    });
  }
}
